import { inject, Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { map, Observable, take, tap } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { Auth } from '@angular/fire/auth';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard {
  private _router: Router = inject(Router);
  private _auth: AuthService = inject(AuthService);
  private _fbAuth: Auth = inject(Auth);

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    let allowedRoles = route.data['allowedRoles'];

    return this._auth.user$.pipe(
      take(1),
      map((user) => {
        return user && this._auth.checkRoleAuthorization(allowedRoles)
          ? true
          : false;
      }),
      tap((canView) => {
        if (!canView) {
          console.error('Access denied. Must have permission to view content');
          this._router.navigate(['/error', 403]);
        }
      }),
    );
  }
}
